import React, { Component } from 'react';
import { connect } from 'react-redux';

class Header extends Component {
  state = {};

  static getDerivedStateFromProps(props, state) {
    fetch(`https://search-api-openedition-org.wikipedialibrary.idm.oclc.org/openbarre?locale=${props.lang}`)
      .then(response => response.text())
      .then(response => {
        const $ = window.$;
        const div = document.getElementById('header-openbar');
        const promises = [];

        div.innerHTML = response
          .replace(
            'function updateCurrentUrl',
            'window.updateCurrentUrl = function'
          )
          .replace("updateCurrentUrl('", "window.updateCurrentUrl('");

        const scripts = div.getElementsByTagName('script');
        for (let i = 0; i < scripts.length; i++) {
          if (scripts[i].innerText) eval(scripts[i].innerText);
          if (scripts[i].src) {
            promises.push(
              new Promise(resolve => $.getScript(scripts[i].src, resolve))
            );
          }
        }

        Promise.all(promises).then(() => {
          const DOMContentLoaded_event = document.createEvent('Event');
          DOMContentLoaded_event.initEvent('DOMContentLoaded', true, true);
          window.document.dispatchEvent(DOMContentLoaded_event);
        });
      });

    return state;
  }

  render() {
    return <div id="header-openbar" />;
  }
}

export default connect(
  ({ ui: lang }) => ({ lang: lang.lang }),
  {}
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js